import React, { useEffect } from 'react';
import CoursesSection from '../components/home/CoursesSection';
import SEO from '../components/SEO';

const Courses = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const breadcrumbs = [
        { name: "Home", url: "/" },
        { name: "All Courses", url: "/courses" }
    ];

    const coursesListSchema = {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        "name": "Explore All Online Courses & Certifications | Skill Ascent",
        "url": "https://www.skillascent.in/courses",
        "description": "Browse 35+ industry-aligned certification courses in IT, Agriculture, Mechanical Engineering, Civil Engineering, Creative Media, Business, and Healthcare."
    };

    return (
        <div style={{ paddingTop: '80px', minHeight: '80vh', backgroundColor: '#f8fafc' }}>
            <SEO
                title="All Online Certification Courses & Programs India | Skill Ascent"
                description="Explore job-ready online certification courses at Skill Ascent. Learn Python Full Stack, Data Science, AI/ML, DevOps, Digital Marketing, Graphic Design, Video Editing, Agriculture, and Engineering."
                keywords="online certification courses, IT courses India, learn python online, digital marketing course, data science course, skill ascent courses, agriculture training, autocad course online"
                canonicalPath="/courses"
                schemaData={coursesListSchema}
                breadcrumbs={breadcrumbs}
            />
            <CoursesSection />
        </div>
    );

};

export default Courses;
